// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nBug","type":"styles_type__Oue01","choices":"styles_choices__12kR6"};